import { getIsNav4Enabled } from './getIsNav4Enabled';

export const useIsNav4Enabled = () => {
	return getIsNav4Enabled();
};
